<template>
  <div v-if="event">
    <h1>오늘하루 이벤트<small class="ml-3 text-muted">{{ event.id > 0 ? '수정' : '추가'}}</small></h1>
    <div class="form-group">
      <label for="event-path">주소</label>
      <input type="text" class="form-control"
             id="event-path"
             placeholder=""
             v-model="event.path"
             name="event-path"
             v-validate="'required|alpha_num|checkPath'"
             :class="{'is-invalid': errors.has('event-path')}">
      <div class="invalid-feedback" v-if="errors.has('event-path')">
        <span v-if="errors.firstRule('event-path') === 'required'">주소를 입력하세요.</span>
        <span
          v-else-if="errors.firstRule('event-path') === 'alpha_num'">알파벳과 숫자만 입력가능합니다.</span>
        <span
          v-else-if="errors.firstRule('event-path') === 'checkPath'">이미 사용중인 주소입니다.</span>
      </div>
    </div>

    <div class="form-group">
      <label for="event-start-at">시작일</label>
      <v-date-picker v-model="event.startAt" :popover="{ visibility: 'click' }">
        <input type="text"
               class="form-control"
               id="event-start-at"
               placeholder=""
               name="event-start-at"
               v-validate="'required'"
               readonly="readonly"
               v-model="startAt"
               :class="{'is-invalid': errors.has('event-start-at')}">
      </v-date-picker>
      <div class="invalid-feedback"
           :class="{'d-block' : errors.has('event-start-at')}"
           v-if="errors.has('event-start-at')">시작일을 입력하세요.
      </div>

    </div>


    <div class="form-group">
      <label for="event-end-at">종료일</label>
      <v-date-picker v-model="event.endAt" :popover="{ visibility: 'click' }">
        <input type="text"
               class="form-control"
               id="event-end-at"
               placeholder=""
               name="event-end-at"
               readonly="readonly"
               v-model="endAt"
               v-validate="'required'"
               :class="{'is-invalid': errors.has('event-end-at')}">
      </v-date-picker>
      <div class="invalid-feedback"
           :class="{'d-block' : errors.has('event-end-at')}"
           v-if="errors.has('event-end-at')">종료일을 입력하세요.
      </div>
    </div>

    <div class="form-group">
      <label>상담 신청</label>
      <div>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="event-use-counsel-true" name="event-use-counsel" class="custom-control-input" :value="true"
                 v-model="event.useCounsel">
          <label class="custom-control-label" for="event-use-counsel-true">사용</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="event-use-counsel-false" name="event-counsel" class="custom-control-input" :value="false"
                 v-model="event.useCounsel">
          <label class="custom-control-label" for="event-use-counsel-false">사용안함</label>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>공개 여부</label>
      <div>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="event-status-true" name="event-status" class="custom-control-input" :value="true"
                 v-model="event.status">
          <label class="custom-control-label" for="event-status-true">공개</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="event-status-false" name="event-status" class="custom-control-input" :value="false"
                 v-model="event.status">
          <label class="custom-control-label" for="event-status-false">비공개</label>
        </div>
      </div>
    </div>

    <div class="form-group" v-for="i in 5" :key="`pc-${i}`">
      <label>
        썸네일 이미지(PC-{{i}})
        <small v-if="event[`pc${i}`] !== null && event[`pc${i}`] !== ''" class="text-muted ml-3">
          {{event[`pc${i}`]}}
          <span class="ml-2 text-danger" style="cursor: pointer" @click="removeImage('pc', i)">삭제</span>
        </small>
      </label>
      <div v-if="event[`pc${i}`] !== null && event[`pc${i}`] !== ''" class="mb-3">
        <!--        <img :src="`${publicPath}upload/event/${event.img1}`" />-->
      </div>
      <div class="custom-file">
        <input type="file" class="custom-file-input" :id="`pc${i}`" :name="`pc${i}`" ref="pc" accept="image/*"
               @change="handleThumb('pc', i)">
        <label class="custom-file-label" :for="`pc${i}`">
          {{ pc[i-1] !== null ? pc[i-1].name : 'Choose file'}}
        </label>
      </div>
    </div>

    <div class="form-group" v-for="i in 5" :key="`mobile-${i}`">
      <label>썸네일 이미지(Mobile-{{i}})<small v-if="event[`mobile${i}`] !== null && event[`mobile${i}`] !== ''"
                                         class="text-muted ml-3">{{event[`mobile${i}`]}}
        <span class="ml-2 text-danger" style="cursor: pointer" @click="removeImage('mobile', i)">삭제</span>
      </small></label>
      <div v-if="event[`mobile${i}`] !== null && event[`mobile${i}`] !== ''" class="mb-3">
        <!--        <img :src="`${publicPath}upload/event/${event.img1}`" />-->
      </div>
      <div class="custom-file">
        <input type="file" class="custom-file-input" :id="`mobile${i}`" :name="`mobile${i}`" ref="mobile" accept="image/*"
               @change="handleThumb('mobile', i)">
        <label class="custom-file-label" :for="`mobile${i}`">
          {{ mobile[i-1] !== null ? mobile[i-1].name : 'Choose file'}}
        </label>
      </div>
    </div>

    <div class="text-center my-5">
      <button type="button" class="btn btn-outline-secondary mx-2" @click="submit">저장</button>
      <button type="button" class="btn btn-outline-secondary mx-2" @click="$router.back()">취소</button>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate';

export default {
  name: 'AdminEventWrite',
  computed: {
    startAt() {
      return this.event.startAt ? this.moment(this.event.startAt).format('YYYY-MM-DD') : '';
    },
    endAt() {
      return this.event.endAt ? this.moment(this.event.endAt).format('YYYY-MM-DD') : '';
    },
  },
  data() {
    return {
      event: null,
      pc: [null, null, null, null, null],
      mobile: [null, null, null, null, null],
    };
  },
  created() {
    Validator.extend('checkPath', {
      validate: (v) => this.$axios.get(`/admin/event/path/${this.event.id}/${v}`)
        .then(
          ({ data }) => ({
            valid: !data,
            data: { message: !data ? '' : 'Already exist email.' },
          }),
          () => ({
            valid: false,
            data: { message: '' },
          }),
        ),
      getMessage: (filed, params, data) => data.message,
    });
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.axios.get(`/admin/event/${this.$route.params.id}`)
        .then(({ data }) => {
          this.event = data;
        })
        .catch(() => {
          this.$router.push({ name: 'adminEventList' });
        });
    } else {
      this.event = {
        id: 0,
        path: '',
        startAt: '',
        endAt: '',
        img1: '',
        img2: '',
        status: false,
        useCounsel: false,
      };
    }
  },
  methods: {
    handleThumb(type, no) {
      const ref = this.$refs[`${type}`][no - 1];
      this.$set(this[`${type}`], no - 1, ref.files.length ? ref.files[0] : null);
    },
    removeImage(type, no) {
      const formData = new FormData();
      formData.append('id', this.event.id);
      formData.append('type', type);
      formData.append('no', no);
      this.$axios.post('/admin/event/removeImage', formData)
        .then(() => {
          this.axios.get(`/admin/event/${this.event.id}`)
            .then(({ data }) => {
              this.event = data;
            })
            .catch(() => {
              this.$router.push({ name: 'adminEventList' });
            });
        });
    },
    async submit() {
      await this.$validator.validateAll();

      if (this.errors.any()) return;

      const formData = new FormData();

      if (this.event.id) {
        formData.append('id', this.event.id);
      }
      formData.append('path', this.event.path);
      formData.append('startAt', this.moment(this.event.startAt).format('YYYY-MM-DD'));
      formData.append('endAt', this.moment(this.event.endAt).format('YYYY-MM-DD'));
      formData.append('useCounsel', this.event.useCounsel);
      formData.append('status', this.event.status);
      this.pc.forEach((file, idx) => {
        if (file) {
          formData.append(`pc${idx + 1}`, file);
        }
      });
      this.mobile.forEach((file, idx) => {
        if (file) {
          formData.append(`mobile${idx + 1}`, file);
        }
      });
      this.$axios({ url: '/admin/event', method: this.event.id > 0 ? 'PUT' : 'POST', data: formData })
        .then(() => {
          this.$router.push({ name: 'adminEventList' });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>

</style>
